import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditQuotesandPolices = withSuspense(lazy(() => import('./edit-deal')));
export default EditQuotesandPolices;
